import { render, staticRenderFns } from "./association-admin-home.vue?vue&type=template&id=2ddf5eab"
import script from "./association-admin-home.vue?vue&type=script&lang=ts"
export * from "./association-admin-home.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports